<template>
  <div class="news-list">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <router-link to="/">{{ $t(`page.index.navTitle`) }}</router-link>
      <span class="separator">></span>
      <span>{{ $t("page.news.navTitle") }}</span>
    </div>

    <div class="content-wrapper">
      <!-- 新闻列表 -->
      <div class="news-main">
        <div class="news-tabs">
          <div
            class="tab-item"
            v-for="tab in tabs"
            :key="tab.id"
            :class="{ active: activeTab === tab.id }"
            @click="switchTab(tab.id)"
          >
            {{ tab.name }}
          </div>
        </div>
        <div class="news-item" v-for="item in paginatedNewsList" :key="item.id">
          <div class="news-image">
            <img :src="item.img" :alt="item.name" @error="handleImageError" />
          </div>
          <div class="news-info">
            <h3 class="news-title">
              <router-link :to="`/news/detail/${item.id}`">{{
                item.name
              }}</router-link>
            </h3>
            <div class="news-meta">
              <span class="date">{{ item.addtime }}</span>
              <span class="views">{{ item.hit }}</span>
            </div>
          </div>
        </div>

        <!-- ElementUI 分页组件 -->
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 20, 50]"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="totalItems"
          >
          </el-pagination>
        </div>
      </div>

      <!-- 侧边栏 -->
      <div class="sidebar">
        <div class="sidebar-section">
          <h3 class="sidebar-title">{{ $t("page.news.sidebarTitle") }}</h3>
          <ul class="hot-news-list">
            <li
              v-for="(item, index) in hotNews"
              :key="item.id"
              class="hot-news-item"
            >
              <div style="display: flex">
                <span class="news-number" :class="{ 'top-three': index < 3 }"
                  >{{ index + 1 }}.</span
                >
                <router-link :to="`/news/detail/${item.id}`" class="news-link">
                  {{ item.name }}
                </router-link>
              </div>
              <div class="news-date">{{ item.addtime }}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  name: "NewsList",
  data() {
    return {
      activeTab: "",
      tabs: [],
      allNewsList: [], // 存储所有新闻数据
      newsList: [], // 当前页显示的新闻数据
      hotNews: [],
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示数量
      totalItems: 0, // 总数据量
    };
  },
  computed: {
    // 计算属性：当前页显示的新闻列表
    paginatedNewsList() {
      return this.newsList;
    },
  },
  created() {
    this.getNewsList();
  },
  methods: {
    switchTab(tabKey) {
      this.activeTab = tabKey;
      this.currentPage = 1; // 切换标签时重置到第一页
      this.getNewsList();
    },
    async getNewsList() {
      try {
        const response = await this.$axios.post(`/api/index/getNewsList`, {
          language: Cookies.get("locale"),
          system: "2",
          page: 1, // 获取所有数据，前端分页
          pageSize: 9999, // 设置一个大数值获取所有数据
          cate_id: this.activeTab,
        });
        const data = response.data;
        this.tabs = data.cate_list;
        this.allNewsList = data.list || []; // 存储所有新闻数据
        this.hotNews = data.hot_list;
        this.totalItems = this.allNewsList.length;
        this.currentPage = 1; // 重置到第一页
        this.updatePaginatedList();
      } catch (error) {
        console.error("获取新闻列表失败:", error);
      }
    },
    // 更新当前页显示的数据
    updatePaginatedList() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      this.newsList = this.allNewsList.slice(start, end);
    },
    // 每页显示数量改变
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1; // 重置到第一页
      this.updatePaginatedList();
    },
    // 当前页改变
    handleCurrentChange(val) {
      this.currentPage = val;
      this.updatePaginatedList();
    },
    handleImageError(e) {
      e.target.src = require("@/assets/images/newsIcon.png");
    },
  },
};
</script>
<style lang="scss" scoped>
.news-list {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;

  .breadcrumb {
    margin-bottom: 20px;
    font-size: 14px;
    color: #666;

    a {
      color: #666;
      text-decoration: none;

      &:hover {
        color: #e93323;
      }
    }

    .separator {
      margin: 0 8px;
    }
  }

  .news-tabs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding: 0;

    .tab-item {
      padding: 10px;
      cursor: pointer;
      color: #666;
      border-bottom: 3px solid transparent;
      transition: all 0.3s;
      font-size: 14px;
      font-weight: 500;

      &:hover {
        color: #e93323;
        // background-color: #fafafa;
      }

      &.active {
        color: #e93323;
        //border-bottom-color: #e93323;
        background-color: #fff;
      }
    }

    .search-box {
      display: flex;
      align-items: center;
      margin-right: 20px;
      border: 1px solid #ddd;
      border-radius: 20px;
      overflow: hidden;
      background-color: #fff;

      input {
        border: none;
        outline: none;
        padding: 8px 15px;
        font-size: 14px;
        width: 200px;
        background-color: transparent;

        &::placeholder {
          color: #999;
        }
      }

      button {
        border: none;
        background-color: #e93323;
        color: white;
        padding: 8px 12px;
        cursor: pointer;
        font-size: 14px;
        transition: background-color 0.3s;

        &:hover {
          background-color: #d12b1f;
        }
      }
    }
  }

  .content-wrapper {
    display: flex;
    gap: 25px;

    .news-main {
      flex: 1;
      min-width: 0;
      background-color: #fff;
      border-radius: 8px;
      padding: 30px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

      .news-item {
        display: flex;
        gap: 15px;
        padding: 20px 0;
        border-bottom: 1px solid #f0f0f0;

        &:first-child {
          padding-top: 0;
        }

        &:last-child {
          border-bottom: none;
          padding-bottom: 0;
        }

        .news-image {
          width: 100px;
          height: 80px;
          flex-shrink: 0;
          overflow: hidden;
          border-radius: 6px;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.3s;

            &:hover {
              transform: scale(1.05);
            }
          }
        }

        .news-info {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          padding-left: 5px;

          .news-title {
            margin: 0 0 25px 0;
            font-size: 15px;
            font-weight: 500;
            line-height: 1.5;
            color: #333;

            a {
              color: #333;
              text-decoration: none;

              &:hover {
                color: #e93323;
              }
            }
          }

          .news-meta {
            display: flex;
            align-items: center;
            gap: 20px;
            font-size: 13px;
            color: #999;
            margin-top: auto;

            .date {
              display: flex;
              align-items: center;

              &::before {
                content: "⏰";
                margin-right: 4px;
                font-size: 12px;
              }
            }

            .views {
              display: flex;
              align-items: center;

              &::before {
                content: "👁";
                margin-right: 4px;
                font-size: 12px;
              }
            }
          }
        }
      }

      .pagination {
        text-align: center;
        margin-top: 20px;

        // ElementUI 分页组件样式自定义
        ::v-deep .el-pagination {
          .el-pagination__total {
            color: #666;
          }

          .el-pager li {
            &:hover {
              color: #e93323;
            }

            &.active {
              background-color: #e93323;
              color: white;
            }
          }

          .el-pagination__jump {
            color: #666;
          }

          .btn-prev,
          .btn-next {
            &:hover {
              color: #e93323;
            }
          }
        }
      }
    }

    .sidebar {
      width: 320px;
      flex-shrink: 0;

      .sidebar-section {
        background-color: #fff;
        border-radius: 8px;
        padding: 25px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

        .sidebar-title {
          font-size: 18px;
          font-weight: 600;
          color: #333;
          margin-bottom: 20px;
          padding-bottom: 12px;
          border-bottom: 2px solid #e93323;
          position: relative;

          &::after {
            content: "";
            position: absolute;
            bottom: -2px;
            left: 0;
            width: 30px;
            height: 2px;
            background-color: #e93323;
          }
        }

        .hot-news-list {
          list-style: none;
          padding: 0;
          margin: 0;

          .hot-news-item {
            margin-bottom: 18px;
            padding-bottom: 18px;
            border-bottom: 1px solid #f0f0f0;

            &:last-child {
              margin-bottom: 0;
              padding-bottom: 0;
              border-bottom: none;
            }

            .news-number {
              display: inline-block;
              width: 24px;
              height: 24px;
              line-height: 24px;
              text-align: center;
              font-weight: bold;
              color: #999;
              font-size: 14px;
              margin-right: 8px;

              // &.top-three {
              //   background-color: #e93323;
              //   color: white;
              //   border-radius: 50%;
              //   font-size: 12px;
              // }
            }

            .news-link {
              color: #333;
              text-decoration: none;
              font-size: 14px;
              line-height: 1.5;
              display: block;
              margin-bottom: 8px;
              font-weight: 500;

              &:hover {
                color: #e93323;
              }
            }

            .news-date {
              font-size: 12px;
              color: #999;
              margin-left: 32px;

              &::before {
                content: "🕒";
                margin-right: 4px;
              }
            }
          }
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .news-list {
    padding: 15px;
    background-color: #f5f5f5;

    .news-tabs {
      flex-wrap: wrap;

      .tab-item {
        padding: 12px 20px;
        font-size: 14px;
        text-align: center;
        min-width: 80px;
      }

      .search-box {
        margin: 10px 20px;
        width: 100%;
        justify-content: center;

        input {
          width: 200px;
        }
      }
    }

    .content-wrapper {
      flex-direction: column;
      gap: 20px;

      .sidebar {
        width: 100%;
        order: -1;
      }

      .news-main {
        padding: 20px;

        .news-item {
          flex-direction: column;
          padding: 20px 0;

          .news-image {
            width: 100%;
            height: 200px;
          }

          .news-info {
            padding-left: 0;
            padding-top: 15px;

            .news-title {
              font-size: 16px;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 480px) {
  .news-list {
    padding: 10px;

    .news-tabs .tab-item {
      padding: 10px 15px;
      font-size: 13px;
    }

    .content-wrapper {
      .news-main {
        padding: 15px;

        .news-item {
          padding: 15px 0;

          .news-image {
            height: 180px;
          }

          .news-info .news-title {
            font-size: 15px;
          }
        }
      }

      .sidebar .sidebar-section {
        padding: 20px;
      }
    }
  }
}
</style>
